module.exports = __webpack_public_path__ + "front/img/content3_wechat.0394c8dd.png";